"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _theme = require("./theme");
var _default = (props, {
  asObject
} = {}) => {
  var _iconSizeVariant;
  const width = props.size ? (_iconSizeVariant = (0, _theme.iconSizeVariant)()) === null || _iconSizeVariant === void 0 ? void 0 : _iconSizeVariant(props) : '100%';
  const height = width;
  return !asObject ? (0, _styledComponents.css)(["width:", ";height:", ";"], width, height) : {
    width,
    height
  };
};
exports.default = _default;
//# sourceMappingURL=iconMixin.js.map